
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component({})
  export default class ModalTabs extends Vue {
    @Prop({ type: Array, required: true}) readonly tabs!: string[];

    selectedTabIndex: number = 0;

    selectedTabStyle(index: number): object {
      return {
        "border-primary": this.selectedTabIndex === index,
      };
    }

    updateTabIndex(index: number): void {
      this.selectedTabIndex = index;
      this.$emit("tabIndexUpdated", index)
    }
  }
